"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynBankCardInfoRequest = void 0;
var SynBankCardInfoRequest = /** @class */ (function () {
    function SynBankCardInfoRequest() {
    }
    return SynBankCardInfoRequest;
}());
exports.SynBankCardInfoRequest = SynBankCardInfoRequest;
;
//# sourceMappingURL=synBankCardInfo.request.js.map